module.exports = __webpack_public_path__ + "static/media/aww.d32a704e.mp3";